import { PaziaSelect } from "components/atoms";
import { useButtonStyles } from "api/shop";

interface ButtonVariantSelectProps {
  name: string;
  label?: string;
  required?: boolean;
}

export const ButtonVariantSelect = ({ name, label = "Wariant", required = false }: ButtonVariantSelectProps) => {
  const { buttonStyles, isLoading } = useButtonStyles();

  const options = buttonStyles.map((style) => ({
    value: style.name,
    label: style.label,
  }));

  // Fallback to legacy options if no styles loaded yet
  const finalOptions = options.length > 0 ? options : LEGACY_BUTTON_VARIANT_OPTIONS;

  return (
    <PaziaSelect
      name={name}
      label={label}
      required={required}
      options={finalOptions}
      disabled={isLoading}
    />
  );
};

// Legacy options for backwards compatibility
const LEGACY_BUTTON_VARIANT_OPTIONS = [
  { value: "primary", label: "Primary" },
  { value: "secondary", label: "Secondary" },
  { value: "outline", label: "Outline" },
];

// Export legacy options for use in schemas that need default values
export { LEGACY_BUTTON_VARIANT_OPTIONS as BUTTON_VARIANT_OPTIONS };
